module.exports = __webpack_public_path__ + "static/Matthieu_Hocquart-c4c4078b3d76dcdba2c7206ef3e80c21.png";